import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
//import { TrackedWebsite, UpdateTrackedWebsitesParams } from '../../../trackedWebsites/types';
import { WebsiteIndexEntry, UpdateWebsiteIndexEntrySettingsParams } from '../../../deepAnalysis/websiteIndexEntry/types';
import { validate } from 'validate.js';
import { urlValidationRule } from '../../../trackedWebsites/utils';

const initialState = {
    newCompetitorUrl: '',
    validationError: '',
};

type Props = {
    selectedWebsite: WebsiteIndexEntry;
    isDisabled: boolean;
    isAddingCompetitor: boolean;
    onCompetitorsChange: (args: UpdateWebsiteIndexEntrySettingsParams, type: 'remove' | 'add') => void;
};

export default function CompetitorsInput({ selectedWebsite, isDisabled, isAddingCompetitor, onCompetitorsChange }: Props) {
    const [state, setState] = useState(initialState);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const newCompetitorUrl = state.newCompetitorUrl.toLowerCase().trim();

        // TODO: the competitor URL should be from a different domain

        // if (selectedWebsite.url === newCompetitorUrl) {
        //     setState({ ...state, validationError: 'The competitor URL must be different than the main URL!' });
        //     return;
        // }

        if (selectedWebsite.settings.competitors.includes(newCompetitorUrl)) {
            setState({ ...state, validationError: 'This competitor is already added to your list!' });
            return;
        }

        const validationError = validate({ url: newCompetitorUrl }, urlValidationRule);

        if (!validationError) {
            const updatedCompetitors = [...selectedWebsite.settings.competitors, newCompetitorUrl];

            onCompetitorsChange(
                {
                    guid: selectedWebsite.guid,
                    competitors: updatedCompetitors,
                },
                'add'
            );

            setState(initialState);
        } else {
            setState({ ...state, validationError: validationError.url });
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState({ newCompetitorUrl: event.target.value, validationError: '' });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Item
                validateStatus={state.validationError ? 'error' : 'success'}
                help={state.validationError}
            >
                <Input.Group
                    compact
                    size="large"
                >
                    <div className="compact-input-group">
                        <Input
                            name="competitorUrl"
                            value={state.newCompetitorUrl}
                            onChange={handleInputChange}
                            placeholder="Add new competitor url"
                            size="large"
                        />

                        <Button
                            type="primary"
                            htmlType="submit"
                            icon="plus"
                            size="large"
                            disabled={isDisabled}
                            loading={isAddingCompetitor}
                        ></Button>
                    </div>
                </Input.Group>
            </Form.Item>
        </Form>
    );
}
